// extracted by mini-css-extract-plugin
module.exports = {"intro":"FindYourSimNumber_intro__cWe9g","title":"FindYourSimNumber_title__WL61P","description":"FindYourSimNumber_description__S0eXg"};